export const VERIFICATION_STATUS = {
  PENDING_AUTOMATIC: {
    INTERNAL: 'pendingAutomaticVerification',
    PLAID: 'PENDING_AUTOMATIC_VERIFICATION',
  },
  PENDING_MANUAL: {
    INTERNAL: 'pendingManualVerification',
    PLAID: 'PENDING_MANUAL_VERIFICATION',
  },
  PLAID_REVOKED: 'plaidRevoked',
  VERIFICATION_FAILED: 'verificationFailed',
  VERIFIED: 'verified',
  UNKNOWN: 'unknown',
} as const;

export const PLAID_ACTION_STATUSES = new Set([
  VERIFICATION_STATUS.PENDING_MANUAL.INTERNAL,
  VERIFICATION_STATUS.PLAID_REVOKED,
]);
